import { SearchController } from '../modules/search_controller'

$(function () {
  var $input = $('.autocomplete-input')

  if (!$input.length) {
    return
  }

  var $block = $('.b-search-result-container'),
    $container = $block.find('.result-container'),
    spinner = $block.find('.b-spinner'),
    scroll_trigger = $block.find('.scroll-trigger'),
    $footer = $('#result_container_footer'),
    cloned_footer = false,
    path = $container.data('path'),
    mobile_path = $input.data('path'),
    desktop_path = $('.header-search .autocomplete-input').data('path'),
    desktop_root_path = $('.header-search .autocomplete-input').data('root-path'),
    $no_result = $block.find('.no-result'),
    $autocomplete = $('.b-search-autocomplete'),
    arrowPress = 0

  // Search toggle
  function toggleSearch(event) {
    event.preventDefault()

    var html = $('html')
    html.toggleClass('opened-search')
    $('#desktop-search').trigger('focus')
    $no_result.hide()

    if (html.hasClass('opened-search')) {
      $container.html('').parent().removeClass('full')
      $input.val('')

      if ($footer) {
        $footer.hide()
      }
    } else {
      $block.hide().removeClass('active')
      window.history.pushState(null, null, desktop_root_path)
    }

    $autocomplete.hide()
    arrowPress = 0
  }

  $('.search-link, .search-close').on('click', function (event) {
    toggleSearch(event)
  })

  // Overlay click
  // Search toggle
  $('.overlay').on('click', function (event) {
    event.preventDefault()

    if ($('html').hasClass('opened-search')) {
      toggleSearch(event)
    }

    if ($('html').hasClass('opened-left')) {
      toggleMenu(event)
    }
  })

  // Process each autocomplete (desktop and mobile)
  $input.each(function () {
    var that = $(this)
    var $autocomplete = $(that.data('autocomplete'))

    if (!$autocomplete.length) {
      return
    }

    // Key down event
    that.keyup(function (event) {
      switch (event.which) {
        case 38: // up
          go_up(event, that, $autocomplete)
          return
        case 40: // down
          go_down(event, that, $autocomplete)
          return
        case 13: // enter
          select_option(event, that, $autocomplete)
          return
      }
      if (that.val() === '') {
        $autocomplete.hide()
        arrowPress = 0
      } else {
        show_autocomplete(that, $autocomplete)
      }
    })

    // Click event
    that.parent().click(function (event) {
      if (that.prop('disabled')) {
        that.val('')
      }

      that.prop('disabled', false).focus()
      $block.hide().removeClass('active')
    })
  })

  // Prevent form submit
  $('form.header-search').on('submit', function (event) {
    event.preventDefault()
  })

  // AUXILIARY METHODS

  // Show results
  function show_results(query) {
    if (IB.currentDevice === 'mobile') {
      window.location.href = mobile_path + encodeURIComponent(query)
      return
    }
    window.history.pushState(null, null, desktop_path + encodeURIComponent(query))

    $no_result.hide()
    $block.show().addClass('active')

    // Clone footer
    if (!cloned_footer) {
      $footer.html($('.page-content .main-footer').html()).addClass('main-footer').show()
      cloned_footer = true
    }

    $container.html('')

    SearchController.init($container, path, query)
    SearchController.reset()
    SearchController.set_finish_event(function (page) {
      if (page == 1) {
        $no_result.show()
      }

      scroll_trigger.off('appear')
    })
    SearchController.set_spinner(spinner)

    // Infinite scroll
    scroll_trigger.appear()
    scroll_trigger.on('appear', function () {
      SearchController.load()
    })

    // Load first page
    SearchController.load(after_load)
  }

  function after_load() {
    $container.parent().addClass('full')
    $footer.show()
  }

  // Up arrow key pressed
  function go_up(event, element, autocomplete) {
    event.preventDefault()

    if (!autocomplete.is(':visible')) {
      show_autocomplete(element, autocomplete)
    }

    var li = autocomplete.find('li')
    arrowPress -= 1

    if (arrowPress === 0) {
      arrowPress = li.length
    }

    li.removeClass('active')
    autocomplete.find(`li:nth-child(${arrowPress})`).addClass('active')

    $input.val(autocomplete.find(`li:nth-child(${arrowPress})`).text())
  }

  // Down arrow key pressed
  function go_down(event, element, autocomplete) {
    event.preventDefault()

    if (!autocomplete.is(':visible')) {
      show_autocomplete(element, autocomplete)
    }

    var li = autocomplete.find('li')
    arrowPress += 1

    if (arrowPress > li.length) {
      arrowPress = 1
    }

    li.removeClass('active')
    autocomplete.find(`li:nth-child(${arrowPress})`).addClass('active')

    $input.val(autocomplete.find(`li:nth-child(${arrowPress})`).text())
  }

  // One option in selected
  function select_option(event, element, autocomplete, selected) {
    if (IB.currentDevice === 'mobile' && typeof selected !== 'undefined') {
      return
    }

    event.preventDefault()

    var query
    if (typeof selected !== 'undefined') {
      query = selected.text()
      element.val(query).prop('disabled', true)
    } else {
      query = element.val()
    }

    autocomplete.hide()
    arrowPress = 0
    show_results(query)
  }

  // Show autocomplete dropdown
  function show_autocomplete(element, autocomplete) {
    autocomplete.show()

    if (element.prop('disabled')) {
      element.val('')
    }

    element.prop('disabled', false).focus()

    var text = element.val().trim()
    var lower_text = text.toLowerCase()
    var list = autocomplete.find('ul').first().html('')
    var length = autocomplete_tags.length
    var no_result_message = autocomplete.find('p')
    var count = 0

    for (var i = 0; i < length; i++) {
      var tag = autocomplete_tags[i]
      var tag_name = tag.name
      var tag_path = tag.path
      var index = tag_name.toLowerCase().indexOf(lower_text)

      if (index == -1) {
        continue
      }

      var content = tag_name

      var li = $('<li/>').appendTo(list)

      var a = $('<a/>')
        .html(content)
        .attr('href', tag_path)
        .appendTo(li)
        .on('click', function (event) {
          select_option(event, element, autocomplete, $(this))
        })

      count++
    }

    if (count) {
      list.show()
      no_result_message.hide()
    } else {
      autocomplete.hide()
      arrowPress = 0
    }
  }
})
